import nodeClient from "./node-client";

export const searchManufacturer = async (query) => {
  const response = await nodeClient(
    `/service/private/v0/search/manufacturer?${encodeURI(query)}`
  );
  return response?.data;
};

export const saveManufacturer = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/add/manufacturer`,
    payload
  );
  return response?.data?.result;
};

export const searchManufacturerGroup = async (payload) => {
  const reponse = await nodeClient.post(
    `/service/protected/v0/manufacturer/group/list`,
    payload
  );
  return reponse?.data?.result?.rows;
};

export const searchManufacturerForProduct = async (query) => {
  const response = await nodeClient(
    `/service/private/v1/search/manufacturer?${encodeURI(query)}`
  );
  return response?.data;
};
